import React from 'react';
import Layout from '../components/Layout';
import PublishedWebinarRouter from '../sections/PublishedWebinar/PublishedWebinarRouter';
import { RouteComponentProps } from '@reach/router';
import { PublicSetWithEWebinarFragment } from '$/GraphQL/schema/schema';
import GdprContextProvider from '$/components/GdprCookie/GdprContext';
import { StaticSetContext } from '$/components/pages/webinar';

const webinar: React.FC<
  RouteComponentProps & {
    pageContext?: {
      set?: PublicSetWithEWebinarFragment;
    };
    location?: Location;
  }
> = ({ location, pageContext }) => {
  return (
    <StaticSetContext.Provider value={{ staticset: pageContext?.set, location }}>
      <Layout noAuth audience>
        <GdprContextProvider>
          <PublishedWebinarRouter />
        </GdprContextProvider>
      </Layout>
    </StaticSetContext.Provider>
  );
};

export default webinar;
